import React from 'react'
import { Box } from '@mantine/core'
import AppCard from './AppCard'
import AppText from './AppText'
import { getTierInfo } from './profileUtils'

export type AmmoScoreTierCardProps = {
  score: number;
  totalVotesReceived?: number;
  approvedSubmissionsCount?: number;
}

export default function AmmoScoreTierCard ({
  score,
  totalVotesReceived = 0,
  approvedSubmissionsCount = 0
}: AmmoScoreTierCardProps) {
  const { current, next, progress } = getTierInfo(score)

  return (
    <AppCard padding="md" sx={{ background: 'var(--gs-surface)', border: '1px solid var(--gs-border)', borderRadius: 8 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <AppText weight={600} size="xs" sx={{ fontFamily: 'Oswald, sans-serif', textTransform: 'uppercase', letterSpacing: 1, color: 'var(--gs-muted)' }}>
          AmmoScore
        </AppText>
        <Box
          sx={{
            background: `${current.color}22`,
            border: `1px solid ${current.color}66`,
            color: current.color,
            padding: '2px var(--gs-sm)',
            borderRadius: 3,
            fontSize: 10,
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 700,
            letterSpacing: 0.5,
            textTransform: 'uppercase'
          }}
        >
          {current.name}
        </Box>
      </Box>

      <AppText sx={{ fontFamily: 'Oswald, sans-serif', fontWeight: 700, fontSize: 28, color: current.color, lineHeight: 1, marginBottom: 'var(--gs-sm)' }}>
        {score}
      </AppText>

      <Box sx={{ marginBottom: 6 }}>
        <Box sx={{ background: 'var(--gs-surface2)', borderRadius: 3, height: 5, overflow: 'hidden' }}>
          <Box
            sx={{
              width: `${progress}%`,
              height: '100%',
              background: `linear-gradient(90deg, ${current.color}99, ${current.color})`,
              borderRadius: 3,
              transition: 'width 0.4s ease'
            }}
          />
        </Box>
        {next
          ? (
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 10, color: 'var(--gs-muted)', marginTop: 'var(--gs-xs)' }}>
            {next.min - score} more to reach{' '}
            <AppText component="span" sx={{ color: next.color, fontWeight: 600 }}>{next.name}</AppText>
          </AppText>
            )
          : (
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 10, color: 'var(--gs-gold)', marginTop: 'var(--gs-xs)', fontWeight: 600 }}>
            Maximum rank achieved
          </AppText>
            )}
      </Box>

      <Box sx={{ borderTop: '1px solid var(--gs-border)', marginTop: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 'var(--gs-xs)' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 11, color: 'var(--gs-muted)' }}>Post votes</AppText>
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 11, color: '#3FB950', fontWeight: 600 }}>+{totalVotesReceived}</AppText>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 11, color: 'var(--gs-muted)' }}>Parts approved</AppText>
          <AppText size="xs" sx={{ fontFamily: 'DM Sans, sans-serif', fontSize: 11, color: '#3FB950', fontWeight: 600 }}>+{approvedSubmissionsCount}</AppText>
        </Box>
      </Box>
    </AppCard>
  )
}
